var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckDocument = function SvgCheckDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 21,
    fill: "none",
    viewBox: "0 0 23 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.62 0h12.66a26 26 0 0 0-1.48 1.817H2.62a.806.806 0 0 0-.803.804v15.758a.8.8 0 0 0 .237.565.8.8 0 0 0 .566.239h17.76a.8.8 0 0 0 .564-.24.8.8 0 0 0 .24-.564V7.787A43 43 0 0 0 23 6.982v11.397c0 .719-.296 1.374-.771 1.85a2.62 2.62 0 0 1-1.85.771H2.62a2.62 2.62 0 0 1-1.85-.77A2.61 2.61 0 0 1 0 18.38V2.62C0 1.902.295 1.248.769.774L.772.769A2.6 2.6 0 0 1 2.62 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.655 8.845 2.57-.034a.62.62 0 0 1 .337.094q.8.457 1.503 1.043.395.331.763.71a41 41 0 0 1 3.033-4.036c1.433-1.691 2.961-3.254 4.323-4.462a.63.63 0 0 1 .416-.157L20.586 2c.346 0 .627.278.627.62 0 .172-.07.326-.184.439a77 77 0 0 0-5.387 6.656c-1.569 2.18-2.99 4.409-4.085 6.502a.629.629 0 0 1-1.122-.022c-.6-1.27-1.315-2.437-2.166-3.477a14 14 0 0 0-2.996-2.744.615.615 0 0 1-.164-.86.63.63 0 0 1 .546-.27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v21H0z"
  })))));
};
export default SvgCheckDocument;